import type { ClassName } from '~/amplienceTypes/partials/exported/element-attributes-schema';

export const hasClassName = (classNames: ClassName, value: string): boolean =>
  Boolean(classNames?.find((className: string) => className.includes(value)));
